import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import Cancel from 'components/inspection/modal/cancel';
import InspectionStatus from 'utils/inspection_state';

const CancelButton = ({ inspection, space, refetch }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();

  return (
    <Button
      variant="outlined"
      disabled={inspection.status !== InspectionStatus().PENDING || !space.adminRole}
      onClick={() => {
        addModal(
          <Cancel
            inspection={inspection}
            handleClose={() => removeModal()}
            onSuccess={() => {
              refetch();
              removeModal();
              setInfo('info.inspection.canceled');
            }}
          />
        );
      }}
    >
      <FormattedMessage id="button.cancel" />
    </Button>
  );
};

export default CancelButton;
